import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeFormatEnum } from '../helpers/enums/enums';
import { IDateTime } from '../interfaces/date-base';
import { convertUtcToCurrentTz, dateTimeObj, formatWithTimeZone, getTodayMonthDay } from '../helpers/utils';
@Pipe({
    name: 'dateCustom'
})


export class DateCustomPipe implements PipeTransform {

    constructor() { }
    transform(date: string | Date, action: DateTimeFormatEnum): any {
        let val: any;
        if (date) {
            let dateO = this.getDate(date, action);
            const { monthDay, monthName, year, time12h, month } = dateO;
            try {
                switch (action) {
                    case DateTimeFormatEnum.MONTH_DAY:
                        val = monthDay;
                        break;
                    case DateTimeFormatEnum.MONTH_NAME:
                        val = monthName;
                        break;
                    case DateTimeFormatEnum.TIME_12:
                        val = time12h;
                        break;
                    case DateTimeFormatEnum.DD_MM_C_YY_H_HH12:
                        //val = formatWithTimeZone(date);
                        val = `${monthDay} ${monthName}, ${year} - ${time12h}`
                        break;
                    case DateTimeFormatEnum.BILLING_DATE:
                        //val = formatWithTimeZone(date);
                        val = ` ${monthName} ${monthDay}, ${year}`
                        break;
                    case DateTimeFormatEnum.IS_TODAY:
                        //val = `${monthDay} ${monthName}`;
                        let currentDateO = this.getDate((new Date()));
                        const { monthDay: cMonthDay, month: cMonth, year: cYear } = currentDateO;
                        val = false;
                        if (monthDay === cMonthDay && cMonth === month && year === cYear) {
                            val = true;
                        }
                        break;
                };
            } catch { }
        }
        return val;
    }

    private getDate(date: any, type?: DateTimeFormatEnum) {
        if (type == DateTimeFormatEnum.DD_MM_C_YY_H_HH12) {
            date = convertUtcToCurrentTz(date);
        }
        return dateTimeObj(date);
    }
}